import { render, staticRenderFns } from "./HighlightRichText.vue?vue&type=template&id=3d68f81a&"
import script from "./HighlightRichText.vue?vue&type=script&lang=js&"
export * from "./HighlightRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports